import {
  IDeviceModelProtocol,
  IDeviceModelProtocolVariant
} from '@/models/IDeviceModel';
import { Chip } from '@destination/components';
import { useTranslation } from 'react-i18next';
import ReactJson from 'react-json-view';
import ModelAttributeCard from '../details/ModelAttributeCard';

export interface IDeviceModelProtocolDetail {
  protocol: IDeviceModelProtocol;
  'data-testid'?: string;
}

export default function DeviceModelProtocolDetail({
  protocol,
  'data-testid': dataTestId
}: IDeviceModelProtocolDetail) {
  const { t } = useTranslation(undefined, { keyPrefix: 'model.device_model' });

  const ProtocolType = () => {
    return (
      <div className="grid grid-cols-[1fr,1fr] gap-4">
        <div>
          {t('key')}: <Chip label={protocol.type.key} className="ml-2" />
        </div>
        <div>
          {t('version')}:{' '}
          <Chip label={protocol.type.version} className="ml-2" />
        </div>
      </div>
    );
  };

  const parseProtocolParameters = (variant: IDeviceModelProtocolVariant) => {
    const jsonObject: { [key: string]: object | string | number } = {};
    variant.parameter_values.forEach(parameter => {
      Object.entries(parameter).forEach(([key, value]) => {
        jsonObject[key] = value;
      });
    });
    return jsonObject;
  };

  const ProtocolVariant = ({
    variant
  }: {
    variant: IDeviceModelProtocolVariant;
  }) => {
    return (
      <ModelAttributeCard
        variant="LIGHT"
        title={
          <div className="flex items-center w-full">
            <div className="tw-text-base w-1/4">{variant.name}</div>
          </div>
        }
      >
        <div data-testid={`protocol-variant-${variant.name}-json`}>
          <ReactJson
            name={null}
            quotesOnKeys={false}
            displayDataTypes={true}
            displayObjectSize={false}
            src={parseProtocolParameters(variant)}
          />
        </div>
      </ModelAttributeCard>
    );
  };

  return (
    <div
      data-testid={dataTestId}
      className="text-base tw-rounded-md mb-2 bg-slate-50 tw-bg-white tw-p-4 tw-shadow-[0_4px_20px_0_rgba(0,0,0,0.1)] p-2 pl-3"
    >
      <ProtocolType />
      <hr className="my-2 h-0.5 border-t-0 bg-neutral-300 opacity-100 dark:opacity-50" />
      <h3 className={'tw-text-base mb-3 '}>Variants:</h3>
      {/* <ProtocolVariantsList variants={protocol.variants} /> */}
      {protocol.variants.map(variant => (
        <ProtocolVariant variant={variant} key={variant.name} />
      ))}
    </div>
  );
}
